module.exports = __webpack_public_path__ + "static/media/F2P_Thumbnail.2dcf7ebb.png";